<template>
  <v-dialog
      :value="value"
      @input="$emit('input', $event)"
      max-width="400"
      persistent
  >
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="warning">mdi-alert-circle</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text v-if="message">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
            text
            @click="handleCancel"
        >
          {{ cancelText }}
        </v-btn>

        <v-btn
            :color="confirmColor"
            :loading="loading"
            @click="handleConfirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Подтвердить действие'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Да'
    },
    cancelText: {
      type: String,
      default: 'Отмена'
    },
    confirmColor: {
      type: String,
      default: 'error'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },

    handleCancel() {
      this.$emit('cancel')
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.headline {
  word-break: normal;
}
</style>